import React, { Component, Fragment } from "react";
import Fallacies from "../../data/Fallacies";
import FallaciesEng from "../../data/FallaciesEng";
import BasicReactModal from "../BasicTools/BasicReactModal";
import MiniPopup from "../Modals and Popovers/MiniPopup";

class ShowFallacies extends Component {
  state = {
    undeterminedNumbers: [0],
    currentNumber: 0,
    wrongNumbers: [],
    rightNumbers: [],
    cheat: false,
    categoriesBool: false,
    content: Fallacies, // peut être Fallacies ou FallaciesEng
    language: "fr", // peut être "fr" ou "en"
    isItRandomOrSorted: "random", // peut être "random" ou "sorted"
    definitionOrExample: 1, // 0=définition & exemple, 1=définition, 2=exemple
    showPDF: "nonexistent",
  };

  resetState() {
    // on remet à zéro les nombres
    let resettedNumbers = [];
    for (let i = 0; i < Fallacies.length; i++) {
      resettedNumbers.push(i);
    }
    const newCurrentNumber =
      resettedNumbers[Math.floor(Math.random() * resettedNumbers.length - 1)];
    this.setState({
      undeterminedNumbers: resettedNumbers,
      currentNumber: newCurrentNumber,
      wrongNumbers: [],
      rightNumbers: [],
    });
  }

  changeBoolean(bool) {
    console.log("wesh", bool);
    if (bool === "language") {
      // changement de langue
      let newContent = Fallacies,
        newLanguage = "fr";
      if (this.state.language === "fr") {
        newContent = FallaciesEng;
        newLanguage = "en";
        this.resetState();
      }
      this.setState({ content: newContent, language: newLanguage });
    } else if (bool === "categoriesBool") {
      let newBool = true;
      if (this.state.categoriesBool) {
        newBool = false;
      }
      this.setState({ categoriesBool: newBool });
    } else if (bool === "PDF") {
      // activation/désactivation de l'affichage du PDF (qui existe, qu'il soit affiché ou non ; la valeur devient soit "", soit "nonexistent")
      let newBool = "";
      if (this.state.showPDF === "") {
        newBool = "nonexistent";
      }
      console.log("bool", newBool);
      this.setState({ showPDF: newBool });
    }
  }

  verifyFallacy(clickedNumber) {
    let newUndeterminedNumbers = this.state.undeterminedNumbers,
      newCurrentNumber = this.state.currentNumber,
      newWrongNumbers = this.state.wrongNumbers,
      newRightNumbers = this.state.rightNumbers;
    if (clickedNumber === this.state.currentNumber) {
      // le nombre est trouvé, donc on va l'enlever d'undeterminedNumbers, le mettre dans rightNumbers, puis resélectionner au hasard un autre nombre dans ceux qui restent
      const position = newUndeterminedNumbers.indexOf(clickedNumber);
      newUndeterminedNumbers.splice(position, 1);
      newRightNumbers.push(clickedNumber);
      const randomNumber = Math.floor(
        Math.random() * newUndeterminedNumbers.length
      );
      newCurrentNumber = newUndeterminedNumbers[randomNumber];
      newWrongNumbers = [];
    } else if (
      clickedNumber !== this.state.currentNumber &&
      !newWrongNumbers.includes(clickedNumber) &&
      !this.state.rightNumbers.includes(clickedNumber)
    ) {
      // ce n'était pas le bon nombre, ET il n'est pas déjà présent dans wrongNumbers, donc on va ajouter le nombre dans wrongNumbers
      newWrongNumbers.push(clickedNumber);
    }
    this.setState({
      undeterminedNumbers: newUndeterminedNumbers,
      currentNumber: newCurrentNumber,
      wrongNumbers: newWrongNumbers,
      rightNumbers: newRightNumbers,
    });
  }

  showFallaciesNames() {
    let arrayToReturn = [];
    for (let i = 0; i < this.state.content.length; i++) {
      let occurrentClassName = "",
        typeClassName = "";
      if (this.state.wrongNumbers.indexOf(i) !== -1) {
        occurrentClassName = "fallacy-button-wrongfullySelected";
      } else if (this.state.rightNumbers.indexOf(i) !== -1) {
        occurrentClassName = "fallacy-button-rightfullySelected";
      } else if (this.state.currentNumber === i && this.state.cheat) {
        occurrentClassName = "fallacy-button-cheatfullySelected";
      }

      if (this.state.content[i].type === "deductive") {
        typeClassName = typeClassName + " deductive-bullet";
      } else if (this.state.content[i].type === "irrelevant") {
        typeClassName = typeClassName + " irrelevant-bullet";
      } else if (this.state.content[i].type === "denial") {
        typeClassName = typeClassName + " denial-bullet";
      } else if (this.state.content[i].type === "inductive") {
        typeClassName = typeClassName + " inductive-bullet";
      }
      let bullet = "";
      if (this.state.categoriesBool) {
        bullet = <p className={typeClassName}>•</p>;
      }

      arrayToReturn.push(
        <li
          key={i}
          className={"fallacy-button " + occurrentClassName}
          onClick={() => this.verifyFallacy(i)}
        >
          {bullet}
          {this.state.content[i].name}
        </li>
      );
    }
    return arrayToReturn;
  }

  showRandomDefinition(currentNumber) {
    if (
      this.state.undeterminedNumbers.length > 0 &&
      this.state.definitionOrExample < 2
    ) {
      return (
        <div className={`fallacy-definition-box ${this.getBoxClass()}`}>
          <p className="fallacy-randomDefinition">
            « {this.state.content[currentNumber].definition} »
          </p>
        </div>
      );
    }
  }

  showRandomExample(currentNumber) {
    if (
      this.state.undeterminedNumbers.length > 0 &&
      this.state.definitionOrExample !== 1
    ) {
      return (
        <div className={`fallacy-example-box ${this.getBoxClass()}`}>
          <p className="fallacy-randomExample">
            « {this.state.content[currentNumber].examples} »
          </p>
        </div>
      );
    }
  }

  getBoxHeight() {
    if (this.state.definitionOrExample === 0) {
      return "auto"; // Both definition and example
    } else if (this.state.definitionOrExample === 1) {
      return "50px"; // Only definition
    } else if (this.state.definitionOrExample === 2) {
      return "50px"; // Only example
    }
  }

  getBoxClass() {
    if (this.state.definitionOrExample === 0) {
      return "both-active"; // Both definition and example
    } else {
      return "single-active"; // Only definition or only example
    }
  }

  toggleCheat() {
    let newCheat = true;
    if (this.state.cheat) {
      newCheat = false;
    }
    this.setState({ cheat: newCheat });
  }

  randomizeOrSort() {
    if (this.state.isItRandomOrSorted === "random") {
    } else if (this.state.isItRandomOrSorted === "sorted") {
    }
  }

  setDefinitionOrExample() {
    let newDefinitionOrExample = this.state.definitionOrExample + 1;
    if (newDefinitionOrExample > 2) {
      newDefinitionOrExample = 0;
    }
    this.setState({ definitionOrExample: newDefinitionOrExample });
  }

  MakePDFWithAllFallacy() {
    // return (
    //   <div id="sheetPrintableFallacies" className={this.state.showPDF}>
    //     <ShowFallaciesCard Fallacies={this.state.content} />
    //   </div>
    // );
  }

  render() {
    // section du point d'interrogation
    const questionMark = (
      <MiniPopup
        iconClass={"icon fas fa-question-circle"}
        title={"A quoi sert cette page ?"}
        text={
          "Cette page a pour but d'aider à mémoriser les noms des raisonnements fallacieux et leurs définitions."
        }
      />
    );

    const togglerCheat = (
      <MiniPopup
        iconClass={"icon pointable fas fa-theater-masks"}
        title={"Activer/désactiver la triche."}
        onClick={() => this.toggleCheat()}
      />
    );

    const togglerLanguage = (
      <MiniPopup
        iconClass={"icon pointable fas fa-flag"}
        title={"Choisir la langue / choose language."}
        onClick={() => this.changeBoolean("language")}
      />
    );

    const togglerInfoIconFallacies = (
      <MiniPopup
        iconClass={"icon pointable fas fa-info-circle"}
        title={"Afficher les catégories de sophismes."}
        onClick={() => this.changeBoolean("categoriesBool")}
      />
    );

    let classNameTogglerDefOrExample = "icon pointable ";
    if (this.state.definitionOrExample === 0) {
      classNameTogglerDefOrExample += "fas fa-sort";
    } else if (this.state.definitionOrExample === 1) {
      classNameTogglerDefOrExample += "fas fa-sort-up";
    } else if (this.state.definitionOrExample === 2) {
      classNameTogglerDefOrExample += "fas fa-sort-down";
    }

    const togglerDefinitionAndOrExample = (
      <MiniPopup
        iconClass={classNameTogglerDefOrExample}
        title={
          "Pour chaque sophisme, afficher sa définition, ou son exemple, ou les deux."
        }
        onClick={() => this.setDefinitionOrExample()}
      />
    );

    const listOfTheFallacies = [];
    for (let i = 0; i < this.state.content.length; i++) {
      let alternateName = "",
        typeClassName = "";
      if (this.state.content[i].alternateName) {
        alternateName = (
          <p className="alternateTitle-single-fallacy-information">
            {this.state.content[i].alternateName}
          </p>
        );
      }
      if (this.state.content[i].type === "deductive") {
        typeClassName = typeClassName + " deductive-bullet";
      } else if (this.state.content[i].type === "irrelevant") {
        typeClassName = typeClassName + " irrelevant-bullet";
      } else if (this.state.content[i].type === "denial") {
        typeClassName = typeClassName + " denial-bullet";
      } else if (this.state.content[i].type === "inductive") {
        typeClassName = typeClassName + " inductive-bullet";
      }
      // On crée un lien si le sophisme a un lien, sinon on affiche juste le nom
      const fallacyName = this.state.content[i].link ? (
        <a
          href={this.state.content[i].link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {this.state.content[i].name}
        </a>
      ) : (
        <span>{this.state.content[i].name}</span>
      );
      listOfTheFallacies.push(
        <li
          key={this.state.content[i].name}
          className={"single-fallacy-information"}
        >
          <div className="title-single-fallacy-information">
            <p className={typeClassName}>•</p>
            {fallacyName}
            {alternateName}
          </div>
          <p className="definition-single-fallacy-information">
            {this.state.content[i].definition}
          </p>
        </li>
      );
    }

    const showListFallacy = (
      <BasicReactModal
        buttonSent={
          <MiniPopup
            iconClass={"fas fa-th-list icon pointable"}
            title={
              "Afficher la liste de tous les raisonnements fallacieux pris en compte sur ce site."
            }
            onClick={() => this.setDefinitionOrExample()}
          />
        }
        contentSent={
          <Fragment>
            <div className="text-all-fallacy-information">
              Voici la liste des sophismes pris en compte sur ce site. Cette
              liste est arbitraire et regroupe des sophismes que j'ai trouvé
              d'une fréquence à peu près égale. Cliquez en dehors de cette liste
              pour la quitter. Cliquez sur l'un des noms de sophisme pour ouvrir
              une page neutre (wikipédia si la page existait) donnant plus de
              détails sur celui-ci. Notez qu'on appelle paralogisme un
              raisonnement qui semble valide mais ne l'est pas (on peut donc
              employer un paralogisme, de bonne foi, sans s'en rendre compte),
              et qu'on appellerait sophisme ce même raisonnement lorsqu'on
              l'emploie pour tromper.
              <br />
              Ceux-ci peuvent être catégorisés en 4 types : <br />
              <p style={{ color: "red" }}>Sophismes déductifs</p>
              Raisonnements abstraits, supposés n'utiliser que la forme logique,
              et ne tenant pas compte de l'expérience du monde. Leurs
              conclusions sont fausses de manière a priori, car leurs
              conclusions ne suivent pas les prémisses.
              <br />
              <p style={{ color: "blue" }}>Sophismes d'incohérence</p>
              Raisonnements qui introduisent des facteurs incohérents, empêchant
              l'écoulement logique d'un argument.
              <br />
              <p style={{ color: "green" }}>Sophismes de réfutation</p>
              Raisonnements utilisés pour réfuter des affirmations.
              <br />
              <p style={{ color: "yellow" }}>Sophismes inductifs</p>
              Raisonnements qui impliquent l'expérience du monde, à partir
              desquelles des conclusions sont tirées. Souvent probabilistes.{" "}
              <br />
            </div>
            <ul className="set-all-fallacy-information">
              {listOfTheFallacies}
            </ul>
          </Fragment>
        }
      />
    );

    const togglerRandomizeOrSort = (
      <MiniPopup
        iconClass={"fas fa-dice "}
        title={
          "Classer les sophismes aléatoirement ou par ordre alphabétique. [non codé]"
        }
        isDeactivated={true}
      />
    );

    const togglerFormalization = (
      <MiniPopup
        iconClass={"fas fa-code-branch "}
        title={
          "Activer/désactiver la formalisation du sophisme à trouver. [non codé]"
        }
        isDeactivated={true}
      />
    );

    const pdfCardShower = (
      <MiniPopup
        iconClass={"fas fa-copy"}
        title={
          "Afficher un PDF permettant d'imprimer tous les sophismes disponibles, sous forme de cartes recto verso. [non codé]"
        }
        isDeactivated={true}
      />
    );

    return (
      <main className="main-page-fallacy">
        {this.MakePDFWithAllFallacy()}
        <h2>
          <div className="set-of-page-icons">
            {questionMark}
            {togglerDefinitionAndOrExample}
            {togglerInfoIconFallacies}
            {togglerLanguage}
            {togglerCheat}
            {showListFallacy}
            {togglerRandomizeOrSort}
            {togglerFormalization}
            {pdfCardShower}
          </div>
        </h2>
        <div className="main-fallacy">
          <p className="fallacy-instruction">
            Cliquez sur le nom de sophisme qui correspond à la définition
            ci-dessous, laquelle est tirée au hasard.
          </p>
          <div className="set-definition-and-counts">
            <div
              className={`fallacy-set-randomDefinitionAndExample ${this.getBoxClass()}`}
            >
              {this.showRandomDefinition(this.state.currentNumber)}
              {this.showRandomExample(this.state.currentNumber)}
            </div>
            <p
              className="set-counts"
              style={{ textAlign: "center", fontSize: "0.8em" }}
            >
              Nombre de sophismes trouvés : {this.state.rightNumbers.length}/
              {this.state.content.length}
            </p>
          </div>
          <ul className="set-fallacy-button">{this.showFallaciesNames()}</ul>
        </div>
      </main>
    );
  }

  componentDidMount() {
    this.resetState();
  }
}

export default ShowFallacies;



// WEBPACK FOOTER //
// ./src/components/Pages/ShowFallacies.js